<template>
  <div>
    <el-button type="primary" @click="openWindow">选择资产</el-button>
    <el-dialog
      append-to-body
      title="选择资产"
      :visible.sync="deviceVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="45%"
    >
      <div style="float: right; margin-right: 30px">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="所属单位">
            <el-cascader
              v-model="formInline.companyCode"
              :disabled="isSelect"
              style="width: 140px"
              :options="companyTree"
              :props="props"
              clearable
              :show-all-levels="false"
              filterable
              placeholder="请选择单位"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="formInline.statue"
              style="width: 140px"
              placeholder="请选择状态"
              clearable
            >
              <el-option
                v-for="item in deviceStatuData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input
              v-model="formInline.content"
              placeholder="搜索内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="findAll">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        ref="singleTable"
        id="singleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="300"
        @current-change="tableCz"
        highlight-current-row
        size="mini"
      >
        <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="zcbh" label="资产编号" width="120">
        </el-table-column>
        <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sbzt" label="设备状态" show-overflow-tooltip>
          <template slot-scope="scope" show-overflow-tooltip>
            <span v-if="scope.row.sbzt == '1'" style="color: gray">准用</span>
            <span v-else-if="scope.row.sbzt == '4'" style="color: orange"
              >报废</span
            >
            <span v-else-if="scope.row.sbzt == '40'" style="color: orange"
              >待维保</span
            >
            <span v-else-if="scope.row.sbzt == '41'" style="color: orange"
              >停用(待检定)</span
            >
            <span v-else-if="scope.row.sbzt == '42'" style="color: orange"
              >调拨</span
            >
            <span v-else-if="scope.row.sbzt == '43'" style="color: orange"
              >停用(待校准)</span
            >
            <span v-else-if="scope.row.sbzt == '44'" style="color: orange"
              >停用(待核查)</span
            >
            <span v-else-if="scope.row.sbzt == '45'" style="color: orange"
              >降级使用</span
            >
          </template>
        </el-table-column>
      </el-table>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="tableData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="transmit">选择</el-button>
        <el-button @click="cancal">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template> 
<script>
import {
  findByUserIdCompanyTree,
  selectAvailableDevice,
  getStatueByDevice,
} from "../../api/api";
export default {
  name: "deviceComponent",
  props: ["transferValue", "personInfo"],
  data() {
    return {
      formInline: {
        statue: "",
        content: "",
        companyCode: "",
      },
      companyTree: [],
      props: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
      },
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      isSelect: false,
      deviceVisible: false,
      tableData: [],
      options: [],
      singleTable: [],
      outData: {},
      deviceStatuData: [],
    };
  },
  methods: {
    //查找设备状态
    findAllType() {
      getStatueByDevice().then((datas) => {
        let { status, message, data } = datas;
        var list = [];
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "设备台账" && data[i].id != 3) {
              list.push({ name: data[i].statusName, id: data[i].id });
            }
          }
          this.deviceStatuData = list;
        }
      });
    },
    // getRowKeys(row) {
    //   return row.id;
    // },
    openWindow() {
      this.deviceVisible = true;
      var user = JSON.parse(localStorage.getItem("user"));
      if (
        user.userRole == 1 ||
        (user.fjqx != null &&
          (user.fjqx.indexOf("3") != -1 || user.fjqx.indexOf("4") != -1))
      ) {
        this.formInline.companyCode = "";
      } else {
        // this.isSelect = true,
        this.formInline.companyCode = [user.companyCode];
      }
      this.formInline.statue = this.personInfo;
      this.findAll();
    },
    tableCz(val) {
      this.outData = {};
      this.outData = val;
    },
    transmit() {
      if (this.outData == null || this.outData == "") {
        this.$message.warning("请选择一条信息"); // .....失败信息
      } else {
        this.transferValue(this.outData);
        this.deviceVisible = false;
      }
    },
    cancal() {
      this.deviceVisible = false;
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var companyCode = "";
      if (
        userinfo.userRole == 1 ||
        (userinfo.fjqx != null &&
          (userinfo.fjqx.indexOf("3") != -1 ||
            userinfo.fjqx.indexOf("4") != -1))
      ) {
        companyCode = "-1";
      } else {
        companyCode = userinfo.companyCode;
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyTree = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
    //查找所有调拨信息
    findAll() {
      var user = JSON.parse(localStorage.getItem("user"));
      let map = {
        companyCode: null,
        content: this.formInline.content,
        state: this.formInline.statue,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        userId: user.userId,
      };
      if (this.formInline.companyCode != null) {
        if (typeof this.formInline.companyCode === "string") {
          map.companyCode = this.formInline.companyCode;
        } else {
          map.companyCode =
            this.formInline.companyCode[this.formInline.companyCode.length - 1];
        }
      }
      selectAvailableDevice(map).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.tableData = data.list;
          this.total = data.total;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.findAll();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.findAll();
    },
  },
  created() {
    this.getCompanyTree();
    this.findAllType();
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/DeviceComponent.vue